import { type PropsWithChildren } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn/cn';
import { notificationVariants } from './Notification.variants';

export type NotificationProps = PropsWithChildren &
  VariantProps<typeof notificationVariants> & { className?: string; contentId: string };

export const FeedbackNotification = ({
  children,
  severity = 'info',
  className,
  contentId,
}: NotificationProps) => (
  <div
    className={cn(
      notificationVariants({ variant: 'feedback', severity }),
      className,
      !children && 'invisible',
    )}
  >
    <span />
    <div className="notification-content" id={contentId}>
      {children}
    </div>
  </div>
);
